import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { LoginRoutingModule } from './login-routing.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Globals } from './globals'
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { HeaderComponent } from './header/header.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { LoginComponent } from './login/login.component';
import { AuthguardServiceService } from './authguard-service.service';
import { MatDialogModule, MatCheckboxModule } from '@angular/material';
import { PopupComponent } from './popup/popup.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ViewsComponent } from './views/views.component';
import { EncrDecrServiceService } from 'src/app/services/encr-decr-service.service';
import { SelectAutocompleteModule } from 'mat-select-autocomplete';
import { MatInputModule } from '@angular/material/input';
import { SpinnerComponent } from './spinner/spinner.component';
import { LoadingInterceptor, Spinner } from './spinner/spinner';
import { SessionexpiredComponent } from './views/sessionexpired/sessionexpired/sessionexpired.component';



@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [

        AppComponent,
        NavMenuComponent,
        HomeComponent,
        CounterComponent,
        FetchDataComponent,
        HeaderComponent,
        SidenavComponent,
        SideMenuComponent,
        LoginComponent,
        PopupComponent,
        ViewsComponent,
        SpinnerComponent,
        SessionexpiredComponent,

       
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        HttpClientModule,
        AppRoutingModule,
        LoginRoutingModule,
        FormsModule,
        MatGridListModule,
        MatMenuModule,
        MatIconModule,
        MatListModule,
        MatExpansionModule,
        MatToolbarModule,
        MatButtonModule,
        MatDatepickerModule,
        RouterModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatAutocompleteModule,
        SelectAutocompleteModule,
        MatCheckboxModule,
        MatInputModule,
        PdfViewerModule,




        //RouterModule.forRoot([
        //  { path: '', component: HomeComponent, pathMatch: 'full' },
        //  { path: 'counter', component: CounterComponent },
        //    { path: 'fetch-data', component: FetchDataComponent },
        //    { path: 'masters/country/countryview', component: CountryviewComponent },
        //    { path: 'masters/country/countryview1', component: Countryview1Component },
        //]),
        BrowserAnimationsModule
    ],
    providers: [AuthguardServiceService, EncrDecrServiceService, Globals, Title, LoadingInterceptor, Spinner],
    bootstrap: [AppComponent],

})
export class AppModule { }
